import { CSVImportUI, Typography } from "matsuri-ui"

import { useAuth } from "m2m-components/storage/useM2mAuth"
import Papa from "papaparse"
import React, { useState } from "react"
import {
    CreateManualReservationInput,
    requestEditManualReservation
} from "../hooks/useCalendar"
import { PageHeader } from "../components/PageHeader"
import { downloadCSVWithBOM } from "../helpers/downloadCSV"
import { requestGetReservation } from "../hooks/useReservation"

export const columns = {
    reservationId: {
        label: "reservationId",
        required: true
    },
    commitionFee: {
        label: "手数料",
        required: true
    }
} as const

type CreateManualReservationInputWithoutOtaId = CreateManualReservationInput & {
    otaId: string
    accepted?: boolean
}

export const ImportManualReservationOtaCommitionFeeFromCsv: React.FC = () => {
    const { token } = useAuth()
    // updateReservationImput
    const [row, setRow] = useState<CreateManualReservationInputWithoutOtaId[]>(
        []
    )

    return (
        <>
            <PageHeader>
                <Typography variant="h2">手動予約の手数料一括更新</Typography>
            </PageHeader>

            <CSVImportUI
                acceptMode={["create"]}
                columns={columns}
                onDownloadCSV={({ data, filename }) => {
                    downloadCSVWithBOM(Papa.unparse(data), filename)
                }}
                csvParser={async ({ file }) => {
                    return new Promise(resolve => {
                        Papa.parse<Record<string, string>>(file, {
                            header: true,
                            skipEmptyLines: "greedy",
                            complete: result => {
                                resolve({ data: result.data })
                            }
                        })
                    })
                }}
                onUploadDataByRow={async ({ index }) => {
                    const { error } = await requestEditManualReservation(
                        token,
                        row[index]
                    )
                    return {
                        error: error
                            ? [columns.reservationId.label, error.message]
                            : undefined
                    }
                }}
                onPreUploadDataByRow={async ({ row: origRow, index }) => {
                    const { data, error } = await requestGetReservation(
                        token,
                        origRow[columns.reservationId.label] ?? ""
                    )
                    if (error) {
                        return {
                            error: [columns.reservationId.label, error.message]
                        }
                    }
                    if (!data) {
                        return {
                            error: [
                                columns.reservationId.label,
                                "予約が見つかりませんでした"
                            ]
                        }
                    }
                    // manualじゃなければ弾く
                    if (data?.reservation.otaInfo.otaType !== "Manual") {
                        return {
                            error: [
                                columns.reservationId.label,
                                "手動予約ではありません"
                            ]
                        }
                    }
                    const commissionFee = {
                        ...data.reservation.commissionFee,
                        rawPrice: parseInt(
                            origRow[columns.commitionFee.label] ?? "",
                            10
                        )
                    }
                    setRow(prev => {
                        const arr = [...prev]
                        arr[index] = {
                            listingId: data.reservation.listingId,
                            roomTypeId: data.reservation.roomTypeId,
                            staySpan: data.reservation.staySpan,
                            numberOfGuests: data.reservation.numberOfGuests,
                            manualType: data.reservation.otaInfo.otaType,
                            fixed: data.reservation.fixed,
                            memo: data.reservation.memo,
                            ownerMemo: data.reservation.ownerMemo,
                            stayType: data.reservation.stayType,
                            statusType: data.reservation.statusType,
                            totalPrice: data.reservation.totalPrice,
                            commissionFee: commissionFee,
                            ownSiteCommissionFee:
                                data.reservation.ownSiteCommissionFee,
                            otaId: data.reservation.otaInfo.otaId
                        }

                        return arr
                    })
                    return {}
                }}
            />
        </>
    )
}

export default ImportManualReservationOtaCommitionFeeFromCsv
